import React from 'react'
import moment from 'moment'
import { Link } from 'react-router-dom'
import _ from 'lodash'
import momentTimezone from 'moment-timezone'
import { isMobile } from 'react-device-detect'
import classNames from 'classnames'

import ReadMore from './../../../../widgets/read_more_2'
import ClipboardCopy from './../../../../widgets/clipboard_copy'
import * as Helpers from './../../../../../helpers/helper'
import * as Constants from './../../../../../helpers/constants'
import CustomOverlayTrigger from './../../../../widgets/overlay_trigger'

export const receiptCreditFormatter = (receipt) => {
  let value = _.get(receipt, 'quantity', '-')

  if (value !== '-')
    value = value.toLocaleString(Constants.CURRENCY.USD.locale)

  return <>{value}</>
}

export const receiptDescriptionFormatter = (receipt) => {
  let val = _.get(receipt, 'description', '-')

  if (val !== '-')
    val = <span style={{ whiteSpace: 'normal', overflowWrap: 'anywhere' }}>{val}</span>

  if (receipt.type === 'paid')
    val = (
      <div className='d-flex flex-column'>
        <span>{receipt.product_details.display_name}</span>
        <span className='text-muted text-uppercase'>
          <small>
            Payment Gateway: {_.startCase(receipt.account_name || receipt.gateway)}
          </small>
        </span>
        {receipt.source?.includes('CRM') && (
          <span style={{ whiteSpace: 'normal', overflowWrap: 'anywhere' }}>
            {receipt.description}
          </span>
        )}
      </div>
    )

  return <>{val}</>
}

export const receiptBillingFormatter = (receipt) => {
  let value = _.get(receipt, 'product_details.renewal', '-')
  let billing = '-'

  if (receipt.type === 'paid')
    if (value === null)
      billing = 'One-Time'
    else
      billing = `${value.count} ${value.unit}`

  return <>{billing}</>
}

export const receiptPaymentFormatter = (receipt) => {
  let value = _.get(receipt, 'payment_type', '-')

  if (value !== '-')
    value = _.startCase(value)

  return <>{value}</>
}

export const receiptAmountFormatter = (receipt) => {
  let value = _.get(receipt, 'amount', '-')
  let formattedAmount = value.toLocaleString(Constants.CURRENCY.USD.locale)
  let val = formattedAmount
  let toolTipContent = <></>

  if (receipt.type === 'paid') {
    let basePrice = receipt.amount_details.base_price.toLocaleString(Constants.CURRENCY.USD.locale)

    if (receipt.amount_details.currency !== Constants.CURRENCY.USD.name) {
      let formattedCurrencyAmount = receipt.amount_details.total_price
        .toLocaleString(Constants.CURRENCY[receipt.amount_details.currency].locale)

      val = formattedCurrencyAmount

      toolTipContent = (
        <div className='d-flex flex-column text-start'>
          <span>
            <small>{'Actual price: '}</small>&nbsp;
            <span>{Constants.CURRENCY.USD.symbol}{basePrice}</span>
          </span>
          <span>
            <small>{'USD equivalent (Incl. tax): '}</small>&nbsp;
            <span>{Constants.CURRENCY.USD.symbol}{formattedAmount}</span>
          </span>
        </div>
      )
    } else {

      toolTipContent = (
        <div className='d-flex flex-column text-start'>
          <span>
            <small>{'Actual price: '}</small>&nbsp;
            <span>{Constants.CURRENCY.USD.symbol}{basePrice}</span>
          </span>
        </div>
      )
    }

    return (
      <>
        <CustomOverlayTrigger
          content={toolTipContent}
          placement={'bottom'}
        >
          <>
            {receipt.amount_details.currency_symbol}
            {val}
          </>
        </CustomOverlayTrigger>
      </>
    )

  }

  return (
    <>{val}</>
  )
}

export const receiptCouponFormatter = (receipt) => {
  let value = _.get(receipt, 'coupon_details')
  let coupon = '-'

  if (value && value.coupon) {
    let couponVal = 0
    let toolTipContent = <></>

    if (value.coupon_type === 'discount') {
      let formattedAmount = value.discount_price.toLocaleString(Constants.CURRENCY.USD.locale)
      let formattedCurrencyAmount
      couponVal = `${Constants.CURRENCY.USD.symbol} ${formattedAmount}`

      if (receipt.amount_details.currency !== Constants.CURRENCY.USD.name) {
        formattedCurrencyAmount = receipt.amount_details.discount_price
          .toLocaleString(Constants.CURRENCY[receipt.amount_details.currency].locale)

        couponVal = `${Constants.CURRENCY[receipt.amount_details.currency].symbol} ${formattedCurrencyAmount}`
        toolTipContent = (
          <div className='d-flex flex-column text-start'>
            <span>
              <small>{'USD Equivalent: '}</small>
              <span>{Constants.CURRENCY.USD.symbol}{formattedAmount}</span>
            </span>
          </div>
        )
      }
    }

    if (value.coupon_type === 'bonus') {
      couponVal = `${value.bonus_value.toLocaleString('en-US')} Credits`
    }

    coupon =
      <div className='d-flex flex-column'>
        <Link to={'/clearout/coupons/' + value.coupon}>
          {value.coupon}
        </Link>
        <span className='text-muted text-uppercase'>
          <small>
            <CustomOverlayTrigger
              content={toolTipContent}
              placement={'bottom'}
            >
              <div>
                {couponVal}
              </div>
            </CustomOverlayTrigger>
          </small>
        </span>
      </div>
  }

  return (
    <>
      {coupon}
    </>
  )
}

export const receiptPurchasedFormatter = (receipt) => {
  let value = receipt.created_on
  return (
    <small>
      {moment(value).format('DD MMM YY, hh:mm:ss A z')}
    </small>
  )
}

export const receiptTypeFormatter = (receipt) => {
  let value = receipt.type

  return (
    <>
      {Helpers.capitalizeFirstLetter(value)}
    </>
  )
}

export const receiptPlanIdFormatter = (receipt) => {
  let value = _.get(receipt, 'product_details.product_id')

  return (
    <>
      <b><small>{value ? value : '-'}</small></b>
    </>
  )
}

export const receiptPayeeInfoFormatter = (receipt) => {
  let value = receipt.payee_details
  let payeeInfo = '-'

  if (value && value.gateway && value.gateway.email_address) {
    payeeInfo = (
      <>
        <span>{value.gateway.name}</span>
        <span className='d-flex justify-content-between'>
          {value.gateway.email_address}&nbsp; &nbsp;
          <ClipboardCopy textToCopy={value.gateway.email_address} />
        </span>
        <span className='d-flex justify-content-between'>
          {value.gateway.user_id}&nbsp; &nbsp;
          <ClipboardCopy textToCopy={value.gateway.user_id} />
        </span>
      </>
    )
  } else if (value && value.co && value.co.email_address) {
    payeeInfo = (
      <>
        <span>{value.co.name}</span>
        <span className='d-flex justify-content-between'>
          {value.co.email_address}&nbsp; &nbsp;
          <ClipboardCopy textToCopy={value.co.email_address} />
        </span>
      </>
    )
  }

  return <>{payeeInfo}</>
}

export const receiptPayeeAddressFormatter = (receipt) => {
  let value = receipt.payee_details
  let payeeAddress = '-'

  if (value && value.gateway && value.gateway.billing_address.country_code) {
    payeeAddress = (
      <>
        <span>
          {
            value.gateway.billing_address.address_line_1
              ? value.gateway.billing_address.address_line_1 + ', '
              : null
          }
          {
            value.gateway.billing_address.address_line_2
              ? value.gateway.billing_address.address_line_2 + ','
              : null
          }
        </span>
        <span>
          {
            value.gateway.billing_address.admin_area_2
              ? value.gateway.billing_address.admin_area_2 + ', '
              : null
          }
          {
            value.gateway.billing_address.admin_area_1
              ? value.gateway.billing_address.admin_area_1 + ','
              : null
          }
        </span>
        <span>
          {
            value.gateway.billing_address.postal_code
              ? value.gateway.billing_address.postal_code + ' - '
              : null
          }
          {
            value.gateway.billing_address.country_code
              ? value.gateway.billing_address.country_code
              : null
          }
        </span>
      </>
    )
  } else if (_.get(value, 'co.billing_address.country.value', null)) {
    payeeAddress = (
      <>
        <span>
          {
            value.co.billing_address.line1
              ? value.co.billing_address.line1 + ', '
              : null
          }
          {
            value.co.billing_address.line2
              ? value.co.billing_address.line2 + ','
              : null
          }
        </span>
        <span>
          {
            value.co.billing_address.city
              ? value.co.billing_address.city + ', '
              : null
          }
          {
            value.co.billing_address.state
              ? value.co.billing_address.state + ','
              : null
          }
        </span>
        <span>
          {
            value.co.billing_address.postal_code
              ? value.co.billing_address.postal_code + ' - '
              : null
          }
          {
            value.co.billing_address.country.value
              ? value.co.billing_address.country.value
              : null
          }
        </span>
      </>
    )
  }

  return (
    <div className='d-flex flex-column'>
      {payeeAddress}
    </div>
  )
}

export const invoiceAndReceiptDownloadFormatter = (receipt, jwtToken, userData, client) => {
  if (receipt.type !== 'paid')
    return null

  const apiInvoicePath = CO_INVOICE_DOWNLOAD_ENDPOINT(client)
  const apiReceiptPath = CO_RECEIPT_DOWNLOAD_ENDPOINT(client)
  return (
    <div className={classNames('d-flex gap-2', { 'flex-column': isMobile })}>
      <a
        href={
          APP_API_URL +
          apiInvoicePath +
          'invoice_id=' + receipt._id +
          '&auth_token=' + jwtToken +
          '&co_user_id=' + userData.user_id
        }
        target="_blank"
        rel="noopener noreferrer"
      >
        {
          isMobile
            ? <span>Invoice</span>
            :
            <i
              className="fa fa-download"
              title="Download Invoice"
            >
            </i>
        }
      </a>
      <a
        href={
          APP_API_URL + apiReceiptPath +
          'receipt_id=' + receipt._id + '&auth_token=' + jwtToken + '&co_user_id=' + userData.user_id
        }
        target="blank"
      >
        {
          isMobile
            ? <span>Receipt</span>
            :
            <i
              className="fa fa-download"
              title="Download Receipt"
            >
            </i>
        }
      </a>
    </div>
  )
}

//cop receipt table formatter
export const copInvoiceAndReceiptDownloadFormatter = (receipt, jwtToken, userData, userName, id) => {
  if (receipt.type !== 'paid')
    return null

  let crmUserData = JSON.stringify({
    name: userName,
    user_id: id
  })

  let requestData = {
    auth_token: jwtToken,
    cop_user_id: userData.user_id,
    client_secret: Constants.CLIENT_SECRET,
    crm_user_data: crmUserData
  }

  let invoiceSearchParams = new URLSearchParams({
    invoice_id: receipt._id,
    ...requestData
  })

  let receiptSearchParams = new URLSearchParams({
    receipt_id: receipt._id,
    ...requestData
  })

  return (
    <div className={classNames('d-flex gap-2', { 'flex-column': isMobile })}>
      <a
        href={
          CLEAROUT_PHONE_BASE_URL + COP_INVOICE_DOWNLOAD_ENDPOINT + invoiceSearchParams.toString()
        }
        target="blank"
      >
        {
          isMobile
            ? <span>Invoice</span>
            :
            <i
              className="fa fa-download"
              title="Download Invoice"
            >
            </i>
        }
      </a>
      <a
        href={
          CLEAROUT_PHONE_BASE_URL + COP_RECEIPT_DOWNLOAD_ENDPOINT + receiptSearchParams.toString()
        }
        target="blank"
      >
        {
          isMobile
            ? <span>Receipt</span>
            :
            <i
              className="fa fa-download"
              title="Download Receipt"
            >
            </i>
        }
      </a>
    </div>
  )
}

export const CO_INVOICE_DOWNLOAD_ENDPOINT = (client) => `api/v1/${client}/download/invoice?`
export const CO_RECEIPT_DOWNLOAD_ENDPOINT = (client) => `api/v1/${client}/download/receipt?`

export const COP_INVOICE_DOWNLOAD_ENDPOINT = 'v1/crm/download/invoice?'
export const COP_RECEIPT_DOWNLOAD_ENDPOINT = 'v1/crm/download/receipt?'

export const pendingInvoiceRenewalDateFormatter = (invoice) => {
  const value = invoice.created_on
  const formattedDate = momentTimezone(value).tz('Asia/kolkata').format('Do MMM, YYYY h:mm A')
  let humanizedDate = momentTimezone(value).tz('Asia/kolkata').fromNow()
  humanizedDate = humanizedDate.replace('ago', '')
  humanizedDate = 'Overdue by ' + humanizedDate

  return (
    <div className="d-flex flex-column">
      <span>{formattedDate}</span>
      <span>
        <small className="text-danger">
          {humanizedDate}
        </small>
      </span>
    </div>
  )
}

export const pendingInvoiceReasonFormatter = (invoice) => {
  const value = invoice.reason
  return (
    <ReadMore
      showReadMore={false}
      showLess={false}
      className=''
      truncateLength={120}
    >
      {value}
    </ReadMore>
  )
}

export const pendingInvoiceLink = (invoice) => {
  let value = invoice.action
  return (
    <a
      href={value.url}
      target="_blank"
      rel="noopener noreferrer"
      title="View Invoice"
    >
      View Invoice
    </a>
  )
}

export const pendingInvoiceProductNameFormatter = (invoice) => {
  return invoice.product_name
}